<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header">
            <h3 class="card-title mb-0">
              <i class="fas fa-table pr-2"></i>
              Gerar Riscos Chaves
            </h3>
          </div>

          <div class="card-body p-2">
            <div class="mat-elevation-z4">
              <mat-toolbar class="table-header">
                <mat-toolbar-row>


                  <div class="input-group input-group-sm" style="width: 500px;">
                    <input type="text" name="table_search" class="form-control float-right" (keyup.enter)="buscarTipoUniversoAuditavel()"
                           placeholder="Escolher Mapeamento" [(ngModel)]="filtroUniverso.pesquisa" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-info" (click)="buscarTipoUniversoAuditavel()">
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                    <input type="text" name="table_search" class="form-control float-right" (keyup.enter)="buscarCriterioAvaliacao()"
                           placeholder="Escolher Critério de Avaliação" [(ngModel)]="filtroCriterios.pesquisa" />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-info" (click)="buscarCriterioAvaliacao()">
                        <i class="fas fa-search"></i>
                      </button>

                    </div>
                  </div>

                  <button type="button" class="btn btn-success btn-sm mr-1" (click)="verificaCriacao()" [disabled]="!universoSelecionado || !criterioSelecionado" >
                    <i class="far fa-file"></i> Gerar
                  </button>

                </mat-toolbar-row>
              </mat-toolbar>
            </div>

            <div class="card-footer">
              <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
                <i class="fas fa-times"></i> Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
